import React from 'react';
import {
  DataPage,
  DataInstrumentsPage,
  DataActiveInstrumentsPage,
  DataDesertSurveyPage,
  DataSurveyPage,
  DataTrackingPage,
  DataActivationStepsPage,
  DataStartActivationPage,
  DataTermsAndConditionsPage,
  DataResultsReportPage,
  DataConfirmSurveyPage,
  DataAdvanceStatusPage,
  ActiveSociogramPage,
  DashboardPage,
  CourseView,
  // UserProfileById,
} from '@BUP/pages';
import { Route, Switch, Redirect } from 'react-router-dom';
import { RoleRoute } from '@BUP/routes';
import { SociogramNavigation } from '@BUP/navigations';

const DataNavigation = () => {
  return (
    <Switch>
      <RoleRoute name="DataPage" component={DataPage} path="/data" exact />
      <RoleRoute
        name="DataInstrumentsPage"
        component={DataInstrumentsPage}
        path="/data/instruments"
        exact
      />
      <RoleRoute
        name="DataActiveInstrumentsPage"
        component={DataActiveInstrumentsPage}
        path="/data/active-instruments"
        exact
      />
      <RoleRoute
        name="DataConfirmSurveyPage"
        component={DataConfirmSurveyPage}
        path="/data/confirm-survey"
        exact
      />
      <RoleRoute
        name="DataDesertSurveyPage"
        component={DataDesertSurveyPage}
        path="/data/confirm-survey/desert-survey"
        exact
      />
      <RoleRoute
        name="DataSurveyPage"
        component={DataSurveyPage}
        path="/data/confirm-survey/survey"
        exact
      />
      <RoleRoute
        name="DataTrackingPage"
        component={DataTrackingPage}
        path="/data/tracking"
        exact
      />
      <RoleRoute
        name="DataAdvanceStatusPage"
        component={DataAdvanceStatusPage}
        path="/data/tracking/advance-status"
        exact
      />
      <RoleRoute
        name="DataActivationStepsPage"
        component={DataActivationStepsPage}
        path="/data/instruments/activation-steps"
        exact
      />
      <RoleRoute
        name="DataStartActivationPage"
        component={DataStartActivationPage}
        path="/data/instruments/request-activation/start-activation"
        exact
      />
      <RoleRoute
        name="DataTermsAndConditionsPage"
        component={DataTermsAndConditionsPage}
        path="/data/instruments/request-activation/start-activation/terms-and-conditions"
        exact
      />
      <RoleRoute
        name="DataResultsReportPage"
        component={DataResultsReportPage}
        path="/data/tracking/results-report"
        exact
      />
      <RoleRoute
        name="ActiveSociogramPage"
        component={ActiveSociogramPage}
        path="/data/active-sociogram"
        exact
      />
      <RoleRoute
        name="DashboardPage"
        component={DashboardPage}
        path="/data/dashboard"
        exact
      />
      <RoleRoute
        name="CourseView"
        component={CourseView}
        path="/data/dashboard/course/:courseId"
        exact
      />
      {/* <RoleRoute
        name="UserProfileById"
        component={UserProfileById}
        path="/data/dashboard/student-profile/:studentId"
        exact
      /> */}
      <Route component={SociogramNavigation} path="/data/sociogram" />

      <Route>
        <Redirect to="/data" />
      </Route>
    </Switch>
  );
};

export default DataNavigation;
